<template>
	<div class="card-container">
		<v-card class="pb-5 card">
			<v-layout wrap pt-2 class="container-title">
				<v-flex xs12 md6 px-4>
					<v-subheader>
						Módulo Seleccionado: {{ moduleName }}
					</v-subheader>
				</v-flex>
			</v-layout>
			<v-layout wrap px-2>
				<v-flex xs12>
					<modules-card-tab
						:columns="columns"
						:current-page="currentPage"
						:module-id="moduleId"
						:tabs="tabs"
						@on-search="$emit('on-search', $event)"
					/>
				</v-flex>
			</v-layout>
		</v-card>
	</div>
</template>

<script>
	import modulesCardTab from '@/components/accounting-rules/modules-card-tab';

	function data() {
		return {
			tabs: [
				{ id: 1, name: 'Cabecera' },
				{ id: 2, name: 'Detalle' },
			],
		};
	}

	export default {
		name: 'modules-card',
		components: {
			modulesCardTab,
		},
		data,
		props: {
			columns: {
				default: () => [],
				type: Array,
			},
			currentPage: {
				default: 1,
				type: Number,
			},
			moduleId: Number,
			moduleName: String,
		},
	};
</script>
<style lang="scss" scoped>
	.card-container, .card {
		border-radius: 20px;
		height: 100%;
	}

	.container-title {
		background-color: color(grey-divider);
	}
</style>



// WEBPACK FOOTER //
// src/components/accounting-rules/modules-card.vue